"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.approvalQueue.title': 'Cola de aprobación',
    'socialMediaPlan.approvalQueue.desc': 'Publicaciones esperando revisión',
    'socialMediaPlan.approvalQueue.proposedDate': 'Fecha propuesta:',
    'socialMediaPlan.approvalQueue.preview': 'Vista previa',
    'socialMediaPlan.approvalQueue.reject': 'Rechazar',
    'socialMediaPlan.approvalQueue.approve': 'Aprobar',
    'socialMediaPlan.approvalQueue.rejectConfirm': '¿Rechazar esta publicación y mover a borrador?',
    'socialMediaPlan.approvalQueue.approved': 'Publicación aprobada para programar',
    'socialMediaPlan.approvalQueue.rejected': 'Publicación movida a borrador',
};
